import React from "react";
import { PropTypes } from "prop-types";
import { MrbModal } from "mrb/components/modal";
import { MrbRouterLink } from "mrb/core/infrastructure/router";
import { defaultTemplate } from "common/hoc";

function DeviceLimitInfoModalTemplate({ modalParams, t }) {
    return (
        <MrbModal
            className="modal__content modal__content--lrg"
            modalParams={modalParams}
            shouldCloseOnOverlayClick={true}
            displayCloseIcon={true}
        >
            <div className="u-type--base u-mar--top--sml">
                <p className="u-type--wgt--bold u-mar--bottom--sml">
                    {t("APPLICATION.PREMIUM.DEVICE_LIMIT_INFO.TITLE")}
                </p>
                <p className="u-mar--bottom--sml">
                    {t("APPLICATION.PREMIUM.DEVICE_LIMIT_INFO.DESCRIPTION")}
                </p>
                <p className="u-mar--bottom--med">
                    {t("APPLICATION.PREMIUM.DEVICE_LIMIT_INFO.ACTION")}
                </p>
                <div className="u-display--flex u-display--flex--jc--center">
                    <MrbRouterLink
                        className="c-btn c-btn--base c-btn--primary u-type--wgt--semibold"
                        routeName="master.application.device.list"
                        onClick={() => modalParams.close()}
                    >
                        {t("APPLICATION.PREMIUM.DEVICE_LIMIT_INFO.GO_TO_DEVICES")}
                    </MrbRouterLink>
                </div>
            </div>
        </MrbModal>
    );
}

DeviceLimitInfoModalTemplate.propTypes = {
    modalParams: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
};

export default defaultTemplate(DeviceLimitInfoModalTemplate);
